var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconSelect24 = function SvgAIconSelect24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#FDEBED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 7L10.3366 16.6214C10.1704 16.8408 9.9162 16.9781 9.63985 16.9976C9.3635 17.0171 9.09221 16.9169 8.89632 16.7229L7 14.8454",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconSelect24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9Im5vbmUiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHJ4PSIyIiBmaWxsPSIjRkRFQkVEIiAvPgo8cGF0aCBkPSJNMTcuNjI1IDdMMTAuMzM2NiAxNi42MjE0QzEwLjE3MDQgMTYuODQwOCA5LjkxNjIgMTYuOTc4MSA5LjYzOTg1IDE2Ljk5NzZDOS4zNjM1IDE3LjAxNzEgOS4wOTIyMSAxNi45MTY5IDguODk2MzIgMTYuNzIyOUw3IDE0Ljg0NTQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+Cg==";